import Swiper from 'swiper';
import 'swiper/swiper-bundle.css';
import { Pagination, Autoplay} from "swiper/modules";

document.addEventListener("DOMContentLoaded", () => {

    const SliderBanner = new Swiper('.swiper-home-banner', {
        modules: [Pagination, Autoplay],
        loop: true,
        autoplay: {
            delay: 3000,
            disableOnInteraction: false
        },
        pagination: {
            el: '.swiper-home-banner-pagination',
            clickable: true,
            // dynamicBullets: true,
        }
    });
});
